import React from 'react';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import CreditMemoRequestItem from '../../../Domain/CreditMemo/CreditMemoRequestItem';
import CreditMemoRequestService from '../../../Services/CreditMemo/CreditMemoRequestService';

class EditCreditMemoRequestWindowDescription extends React.Component {
  static titleForCreate = 'Add New Credit Memo Request';
  static titleForEdit = 'Edit Credit Memo Request';
  static itemType = CreditMemoRequestItem;
  static serviceFunction = (edited) => CreditMemoRequestService.UpsertCreditMemoRequest(edited);

  static navigateToOnCreation = '/creditmemo/search?tab=1&ClientInvoiceId=';

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ClientId',
          label: 'Client *',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => item.CreditMemoRequestId !== '' || JSON.parse(item.FromClientInvoice),
        },
        {
          fieldName: 'ClientInvoiceId',
          label: 'Invoice *',
          className: 'col-12',
          type: InputTypesEnum.CreditMemoRequestInvoiceSelect,
          idFilter: 'ClientId',
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => item.CreditMemoRequestId !== '' || JSON.parse(item.FromClientInvoice),
        },
        {
          fieldName: 'ReasonCode',
          label: 'Reason *',
          className: 'col-12',
          type: InputTypesEnum.CreditMemoReasonLookupItemSelect,
          validityChecker: ValidityHelper.forCreditMemoRequestReasonChange,
          hide: (item) => !['Created', ''].includes(item.Status),
        },
        {
          fieldName: 'InternalReferenceNumber',
          label: 'Internal Reference #',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !['Created', ''].includes(item.Status),
        },
        {
          fieldName: 'Description',
          label: 'Description *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => !['Created', ''].includes(item.Status),
        },
        {
          fieldName: 'InternalInformation',
          label: 'Internal Information *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) => !['Created', ''].includes(item.Status),
        },
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To *',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          roleKey: 'creditmemo_editassignee',
          hide: (item) => item.CreditMemoRequestId === '',
        },
      ],
    },
  ];
}

export default EditCreditMemoRequestWindowDescription;
